export default {
  namespaced: true,
  bulk_edit: {
    title: "Cambios masivos",
    modal_title: "Edición masiva",
    activate_mode: "Activar selección múltiple",
    multi_select: "Selección múltiple",
    select_all: "Seleccionar todo",
    exit: "Salir de la selección",
    edit_selected: "Editar ({count})",
    info_message: "Se modificarán {count} registros seleccionados.",
    only_filled_fields: "Solo se actualizarán los campos que tengan un valor seleccionado. Los campos vacíos no se modificarán.",
    select_placeholder: "Sin cambios",
    select_dependency_placeholder: "Selecciona {field} primero",
    apply_changes: "Aplicar cambios ({count})",
    success: "Actualización masiva exitosa",
    confirm_title: "Confirmar cambios masivos",
    confirm_body: "¿Estás seguro de aplicar los cambios a {count} registros?",
    batch_progress_title: "Actualización masiva en curso",
    batch_progress_text: "Procesando {count} registros...",
    batch_cancelled: "La actualización masiva fue cancelada",
    batch_status_error: "No se pudo consultar el estado de la actualización masiva",
    batch_in_progress: "Ya hay una actualización masiva en curso, espera a que termine",
    enable_field: "modificar este campo",
    cameras_selected: "{count} dispositivos seleccionados",
    assign_selected: "Dispositivos a asignar",
    assign_count: "{count} para asignar",
    device_id: "ID Cámara Proxy: {id}",
    assign_all: "Asignar todos",
    assign_all_warning: "Se asignarán TODOS los dispositivos que coincidan con los filtros a los usuarios seleccionados.",
    unassign_all: "Desasignar todos",
    unassign_all_warning: "Se quitarán de los usuarios seleccionados TODOS los dispositivos que coincidan con los filtros.",
    replace_lists_hint: "Las listas seleccionadas (tenants, tipos de alarma, módulos) reemplazarán por completo las asignadas a cada usuario.",
    additional_info_hint: "Esta lista reemplazará por completo la información adicional de cada registro seleccionado.",
    emergency_contact_hint: "Esta lista reemplazará por completo los contactos de emergencia de cada registro seleccionado.",
  },
};
